require('./index.css')







// WEBPACK FOOTER //
// ./modules/game_header/index.js